import { useEffect } from "react";

const LogoutPage = ({ onLogout }) => {
  useEffect(() => {
    onLogout();
  }, []); // 初回マウント時のみ実行

  return null;
};

export default LogoutPage;
